/* Rewrite article-body Ghost-hosted images to Cloudinary fetch URLs when Cloudinary is configured. */
(function () {
    const body = document.body;

    if (!body) {
        return;
    }

    const cloudName = body.dataset.cloudinaryCloudName;
    const fetchTransform = body.dataset.cloudinaryFetchTransform || 'f_auto,q_auto,dpr_auto,c_limit';
    const srcsetFetchTransform = 'f_auto/q_auto/dpr_auto/c_limit%2C';

    if (!cloudName) {
        return;
    }

    const origin = window.location.origin;
    const maxWidth = 2400;

    function normalizeSourceUrl(url) {
        if (!url) {
            return '';
        }

        const absoluteUrl = new URL(url, origin).href;

        return absoluteUrl
            .replace(/\/content\/images\/size\/[^/]+\/format\/[^/]+\//, '/content/images/')
            .replace(/\/content\/images\/size\/[^/]+\//, '/content/images/');
    }

    function isGhostContentImage(url) {
        return url.includes('/content/images/') && !url.includes('res.cloudinary.com/');
    }

    function buildCloudinaryUrl(url, width, isSrcsetCandidate = false) {
        const normalizedUrl = normalizeSourceUrl(url);

        if (!isGhostContentImage(normalizedUrl)) {
            return url;
        }

        const normalizedWidth = width ? Math.min(width, maxWidth) : null;

        if (isSrcsetCandidate && normalizedWidth) {
            return `https://res.cloudinary.com/${cloudName}/image/fetch/${srcsetFetchTransform}w_${normalizedWidth}/${normalizedUrl}`;
        }

        const widthTransform = normalizedWidth ? `,w_${normalizedWidth}` : '';
        return `https://res.cloudinary.com/${cloudName}/image/fetch/${fetchTransform}${widthTransform}/${normalizedUrl}`;
    }

    function rewriteSrcset(srcset) {
        if (!srcset) {
            return srcset;
        }

        return srcset
            .split(',')
            .map((entry) => entry.trim())
            .filter(Boolean)
            .map((entry) => {
                const parts = entry.split(/\s+/);
                const sourceUrl = parts[0];
                const descriptor = parts.slice(1).join(' ');
                const widthMatch = descriptor.match(/(\d+)w/);
                const width = widthMatch ? parseInt(widthMatch[1], 10) : null;
                const rewrittenUrl = buildCloudinaryUrl(sourceUrl, width, true);

                return descriptor ? `${rewrittenUrl} ${descriptor}` : rewrittenUrl;
            })
            .join(', ');
    }

    document.querySelectorAll('.gh-content img[src]').forEach((image) => {
        const sourceUrl = image.getAttribute('src');

        if (!sourceUrl) {
            return;
        }

        const renderedWidth = Math.max(image.clientWidth || 0, image.width || 0);
        const desiredWidth = renderedWidth > 0 ? Math.ceil(renderedWidth * Math.max(window.devicePixelRatio || 1, 1)) : 1600;

        if (!sourceUrl.includes('res.cloudinary.com/')) {
            image.src = buildCloudinaryUrl(sourceUrl, desiredWidth);
        }

        if (image.srcset && !image.srcset.includes('res.cloudinary.com/')) {
            image.srcset = rewriteSrcset(image.srcset);
        }
    });

    document.querySelectorAll('.gh-content source[srcset]').forEach((source) => {
        const srcset = source.getAttribute('srcset');

        if (!srcset) {
            return;
        }

        if (!srcset.includes('res.cloudinary.com/')) {
            source.srcset = rewriteSrcset(srcset);
        }
    });
})();
